
import { StoreCronStateEnum } from './cron.enum'
import { IStoreCronState } from './cron.interface'

export default {
  [StoreCronStateEnum.CHECK_ACCESS_TOKEN]: undefined
} as IStoreCronState
